// This file contains constants for task names
export const WELLNESS_SURVEY = 'EPIC-26';
export const FREE_TEXT_SURVEY = 'FREE-TEXT';
export const LAB_WORK = 'LAB WORK';
export const IMAGING = 'IMAGING';
